var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.creating)?_c('creating',{attrs:{"height":"50px"}}):_vm._e(),_vm._v(" "),(!_vm.creating)?_c('ul',{staticClass:"list-group"},_vm._l((_vm.shares),function(item,index){return _c('li',{key:index,staticClass:"list-group-item"},[_c('CandidateShareListItem',{attrs:{"share":item}})],1)}),0):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11944402","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Candidate/Share/CandidateShareList.vue
// module id = null
// module chunks = 